import { Link } from "react-router-dom";
import { MessageSquare, Bot, BarChart3, ShieldCheck } from "lucide-react";

const POINTS = [
  { icon: MessageSquare, text: "Shared team inbox for WhatsApp & Instagram" },
  { icon: Bot, text: "Chatbots, auto-replies and an AI assistant" },
  { icon: BarChart3, text: "Campaigns, CRM pipeline and analytics" },
  { icon: ShieldCheck, text: "Official Meta Cloud API — your number, your data" },
];

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="flex min-h-screen bg-background">
      <div className="hidden w-[46%] flex-col justify-between bg-sidebar p-10 text-white lg:flex xl:p-14">
        <Link to="/" className="flex items-center gap-2.5 no-underline">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary">
            <svg viewBox="0 0 64 64" className="h-5 w-5" fill="currentColor" aria-hidden>
              <path d="M18 20h7l4.5 15 5-15h6l5 15 4.5-15h7l-8.5 26h-6.5l-4.5-13.5L33 46h-6.5z" />
            </svg>
          </div>
          <span className="font-display text-xl font-bold tracking-tight">Wappy</span>
        </Link>
        <div>
          <h2 className="max-w-md font-display text-4xl font-bold leading-[1.04] tracking-[-0.02em] xl:text-5xl">
            Tell it the goal. AI plans, writes and runs your <span className="text-lime">WhatsApp campaigns.</span>
          </h2>
          <ul className="mt-8 space-y-3.5">
            {POINTS.map((p) => (
              <li key={p.text} className="flex items-center gap-3 text-[15px] text-sidebar-foreground">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/5"><p.icon className="h-4 w-4 text-lime" /></span>
                {p.text}
              </li>
            ))}
          </ul>
        </div>
        <p className="text-xs text-sidebar-muted">Built on the WhatsApp Business Platform (Cloud API) and the Meta Graph API.</p>
      </div>
      <div className="flex flex-1 items-center justify-center px-4 py-10 sm:px-8">
        <div className="w-full max-w-[400px]">
          <div className="mb-6 flex items-center gap-2 lg:hidden">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-white">
              <svg viewBox="0 0 64 64" className="h-4 w-4" fill="currentColor" aria-hidden><path d="M18 20h7l4.5 15 5-15h6l5 15 4.5-15h7l-8.5 26h-6.5l-4.5-13.5L33 46h-6.5z" /></svg>
            </div>
            <span className="font-semibold">Wappy</span>
          </div>
          <h1 className="font-display text-[28px] font-bold tracking-tight">{title}</h1>
          {subtitle && <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>}
          <div className="mt-6">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
